import { render, staticRenderFns } from "./GamesLinkList.vue?vue&type=template&id=060d4c9a&"
import script from "./GamesLinkList.vue?vue&type=script&lang=js&"
export * from "./GamesLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports